import {Link, useLocation} from 'react-router-dom'
import classNames from 'classnames'
import {useEffect, useState} from 'react'
import './index.scss'
import {useSelector} from 'react-redux'
import {useNamespaceTranslations} from '../../../utils/hooks/useNamespacesTranslations'
import {envConfig} from '../../../utils/env'

const {isIntegrationEnabled} = envConfig

const getTabs = text => ([
    {
        key: 'integrations',
        url: '/integrations',
        label: text.integrations,
        hideIfFeatureDisabled: !isIntegrationEnabled
    },
    {
        key: 'team_channels',
        url: '/notifications/team',
        label: text.team_channels
    },
    {
        key: 'personal_channels',
        url: '/notifications/personal',
        label: text.personal_channels
    }
])

const IntegrationTeamMenu = ({tabs}) => {
    const [activeTab, setActiveTab] = useState(null)
    const {pathname} = useLocation()
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)
    const text = useNamespaceTranslations('integrations-team-menu')
    const allTabs = tabs || getTabs(text)

    useEffect(() => {
        setActiveTab(allTabs.find(({url}) => pathname?.includes(url))?.key)
    }, [pathname])

    return (
        <div className={classNames('menu', {
            dark: isDarkMode
        })}>
            {allTabs.map(({key, url, label, hideIfFeatureDisabled}) => (
                !hideIfFeatureDisabled && <span key={key} className={classNames('menu-tab', {'active': activeTab === key})}>
                    <Link to={url}>{label}</Link>
                </span>
            ))}
        </div>
    )
}

export default IntegrationTeamMenu
